/* Alvaura: retain the offer teaser, move it away from visible controls. */
(() => {
  let frame = 0;
  let lastPosition;
  const placeTeaser = () => {
    frame = 0;
    const teaser = document.querySelector('div[class*="kl-teaser-"]');
    if (!teaser || teaser.matches(':active')) return;
    const size = 44;
    const gap = 10;
    const width = document.documentElement.clientWidth;
    const header = document.getElementById('header-group')?.getBoundingClientRect();
    const headerRects = [...document.querySelectorAll('header, header a')].map((element) => element.getBoundingClientRect())
      .filter((rect) => rect.width && rect.height && rect.bottom > 0 && rect.top < window.innerHeight / 3);
    const headerBottom = Math.max(54, header?.bottom || 0, ...headerRects.map((rect) => rect.bottom));
    const top = Math.max(gap, Math.min(window.innerHeight / 3, headerBottom) + gap);
    const preview = document.getElementById('PBarNextFrame')?.getBoundingClientRect();
    const bottomEdge = preview && preview.height < window.innerHeight / 3 && preview.top > 0
      ? Math.min(window.innerHeight, preview.top) : window.innerHeight;
    const bottom = Math.max(top, bottomEdge - size - gap);
    const right = Math.max(gap, width - size - gap);
    const slots = [[gap, bottom], [right, bottom], [right, top], [gap, top]];
    const controls = [...document.querySelectorAll('button, [role="button"], input:not([type="hidden"]), select, label, a, .ks-chart-modal-link, .sizing-chart-modal-link')]
      .filter((element) => !teaser.contains(element) && getComputedStyle(element).visibility !== 'hidden'
        && getComputedStyle(element).opacity !== '0' && !element.closest('[hidden], [inert], [aria-hidden="true"]'))
      .map((element) => ({ element, rect: element.getBoundingClientRect() }))
      .filter(({ element, rect }) => rect.width && rect.height && rect.bottom > top && rect.top < bottomEdge
        && (element.matches('.ks-chart-modal-link, .sizing-chart-modal-link') || element.tagName !== 'A' || (rect.height < 80 && element.textContent.trim())));
    const score = ([x, y]) => controls.reduce((total, { rect }) => total
      + Math.max(0, Math.min(x + size + 4, rect.right) - Math.max(x - 4, rect.left))
      * Math.max(0, Math.min(y + size + 4, rect.bottom) - Math.max(y - 4, rect.top)), 0);
    let chosen = lastPosition
      ? [Math.min(right, Math.max(gap, lastPosition[0])), Math.min(bottom, Math.max(top, lastPosition[1]))]
      : slots[0];
    let lowest = score(chosen);
    slots.forEach((slot) => {
      const value = score(slot);
      if (value < lowest) { lowest = value; chosen = slot; }
    });
    if (lowest > 0) {
      findSpace: for (let y = top; y <= bottom; y += 8) {
        for (const x of [gap, right, Math.max(gap, (width - size) / 2)]) {
          const candidate = [x, y];
          const value = score(candidate);
          if (value < lowest) { lowest = value; chosen = candidate; }
          if (lowest === 0) break findSpace;
        }
      }
    }
    lastPosition = chosen;
    teaser.style.setProperty('--alvaura-offer-x', chosen[0] + 'px');
    teaser.style.setProperty('--alvaura-offer-y', chosen[1] + 'px');
  };
  const schedule = () => { if (!frame) frame = requestAnimationFrame(placeTeaser); };
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  document.addEventListener('focusin', schedule);
  document.addEventListener('pointerup', schedule, { capture: true, passive: true });
  document.addEventListener('pointercancel', schedule, { capture: true, passive: true });
  const observer = new MutationObserver(schedule);
  observer.observe(document.body, { childList: true, subtree: true });
  schedule();
})();
